import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { Union } from 'ts-toolbelt';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDateInPast, isDateOnOrAfterDOB, isPresent } from 'forms/validators';
import { Gender } from 'types/graph';

import { DiabetesFormValues } from '../form/types';

interface DiabetesValidatorProps {
  dateOfBirth: Union.Nullable<string>;
  gender: Union.Nullable<Gender>;
}

export const getValidator = ({ dateOfBirth, gender }: DiabetesValidatorProps) => {
  const dobValidator = composeValidators(isPresent, isDateInPast, isDateOnOrAfterDOB(dateOfBirth));

  return ({
    currentlyTreated,
    diabetesType,
    diagnosedAt,
    gestational,
    hasHadComplications,
    insulinUnits,
    lastA1cReading,
    lastTreatmentDate,
    twelveMonthAverageA1cReading,
  }: InitialValues<DiabetesFormValues>): ValidationErrors<DiabetesFormValues> => {
    const errors: ValidationErrors<DiabetesFormValues> = {
      diagnosedAt: dobValidator(diagnosedAt),
      diabetesType: isPresent(diabetesType),
      hasHadComplications: isPresent(hasHadComplications),
      currentlyTreated: isPresent(currentlyTreated),
      insulinUnits: isPresent(insulinUnits),
      lastA1cReading: isPresent(lastA1cReading),
      twelveMonthAverageA1cReading: isPresent(twelveMonthAverageA1cReading),
    };

    if (gender === Gender.Female && diabetesType === 2) {
      errors.gestational = isPresent(gestational);
    }

    if (currentlyTreated === false) {
      errors.lastTreatmentDate = dobValidator(lastTreatmentDate);
    }

    return omitBy(errors, isNil);
  };
};
